var render = function (_h,_vm) {var _c=_vm._c;return _c('el-row',{staticClass:"footer",attrs:{"type":"flex","justify":"center","align":"center"}},[_vm._v(" 未经上汽集团同意，不得转载本网站之所有招聘信息及作品。上汽集团版权所有© ")])}
var staticRenderFns = []

export { render, staticRenderFns }